import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth.js'
import { isOnboarded } from '../pages/OnboardingPage.js'
import Skeleton from './Skeleton.js'

export default function PrivateRoute() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <Skeleton rows={6} style={{ padding: '2rem' }} />
  if (!user)   return <Navigate to="/auth" replace />

  // Redirect to onboarding if not yet completed — but don't redirect if already on /onboarding
  if (!isOnboarded(user.uid) && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />
  }

  return <Outlet />
}
